<template>
    <div class="row" v-if="isValid('CanViewColor')">
        <div class="col-lg-12 col-sm-12 ml-auto mr-auto">
            <div class="card">
                <div class="BorderBottom ml-2 mr-2 mt-3 mb-3">
                    <span class=" DayHeading" v-if="formName=='WarrantyCategory'">{{ $t('ReparingOrder.WarrantyCategory') }}</span>
                    <span class=" DayHeading" v-if="formName=='UpsDescription'">{{ $t('ReparingOrder.UpsDescription') }}</span>
                    <span class=" DayHeading" v-if="formName=='Problem'">{{ $t('ReparingOrder.Problem') }}</span>
                    <span class=" DayHeading" v-if="formName=='AcessoryIncluded'">{{ $t('ReparingOrder.AcessoryIncluded') }}</span>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>{{ $t('ReparingOrder.SearchbyName') }}</label>
                                <div>
                                    <input type="text" class="form-control search_input" v-model="search" name="search" id="search" :placeholder="$t('ReparingOrder.Search')" />
                                    <span class="fas fa-search search_icon"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-bind:class="$i18n.locale == 'en' ? 'text-right' : 'text-left'">
                            <a href="javascript:void(0)" class="btn btn-primary" style="margin-top:27px;" v-on:click="openmodel" v-if="isValid('CanAddColor')"><i class="fa fa-plus"></i>  {{ $t('ReparingOrder.AddNew') }}</a>
                            <router-link :to="'/ReparingOrderSetup'">
                                <a href="javascript:void(0)" class="btn btn-outline-danger " style="margin-top:27px;">  <i class="fas fa-arrow-circle-left fa-lg"></i> </a>
                            </router-link>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <table class="table table-striped table-hover table_list_bg" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'arabicLanguage'">
                                <thead class="">
                                    <tr>
                                        <th>#</th>

                                        <th v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'text-right'">
                                            {{ $t('ReparingOrder.ReparingOrderName') |englishLanguage}}
                                        </th>
                                        <th v-if="arabic=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'text-right'">
                                            {{ $t('ReparingOrder.ReparingOrderName') |arabicLanguage}}
                                        </th>
                                     
                                        <th v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'text-right'">
                                            {{ $t('ReparingOrder.Status') }}
                                        </th>


                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(reparingOrder,index) in reparingOrderlist" v-bind:key="reparingOrder.id">
                                        <td v-if="currentPage === 1">
                                            {{index+1}}
                                        </td>
                                        <td v-else>
                                            {{((currentPage*10)-10) +(index+1)}}
                                        </td>

                                        <!--<td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'text-right'" v-if="isValid('CanEditColor')">
                                            <strong>
                                                <a href="javascript:void(0)" v-on:click="EditreparingOrder(reparingOrder.id)">  {{reparingOrder.code}}</a>
                                            </strong>
                                        </td>-->
                                        <!--<td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'text-right'" v-else>
                                            {{reparingOrder.code}}

                                        </td>-->
                                        <td v-if="english=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'text-right'">
                                            <strong>
                                                <a href="javascript:void(0)" v-on:click="EditReparingOrder(reparingOrder.id)">    {{reparingOrder.name}}</a>
                                            </strong>

                                        </td>
                                        <td v-if="arabic=='true'" v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'text-right'">
                                            <strong>
                                                <a href="javascript:void(0)" v-on:click="EditReparingOrder(reparingOrder.id)">    {{reparingOrder.nameArabic}}</a>
                                            </strong>

                                        </td>
                                        
                                        <td v-bind:class="$i18n.locale == 'en' ? 'text-left' : 'text-right'">{{reparingOrder.isActive==true?$t('ReparingOrder.Active'):$t('ReparingOrder.De-Active')}}</td>



                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                    <div class="float-left">
                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                        <span v-else-if="currentPage===1 && rowCount < 10">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage===1 && rowCount >= 11  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                    </div>
                    <div class="float-right">
                        <div class="overflow-auto" v-on:click="GetReparingOrderData()">
                            <b-pagination pills size="lg" v-model="currentPage"
                                          :total-rows="rowCount"
                                          :per-page="10"
                                          first-text="First"
                                          prev-text="Previous"
                                          next-text="Next"
                                          last-text="Last"></b-pagination>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <reparingOrdermodel :reparingOrder="newReparingOrder"
                            :show="show"
                            :formName="formName"
                            v-if="show"
                            @close="IsSave"
                            :type="type" />

    </div>
    <div v-else> <acessdenied></acessdenied></div>

</template>

<script>
    import clickMixin from '@/Mixins/clickMixin'
    export default {
        props: ['formName'],

        mixins: [clickMixin],
        data: function () {
            return {
                arabic: '',
                english: '',
                searchQuery: '',
                show: false,
                reparingOrderlist: [],
                newReparingOrder: {
                    id: '',
                    name: '',
                    nameArabic: '',
                    description: '',
                    reparingOrderTypes: '',
                    code: '',
                    isActive: true
                },
                type: '',
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
            }
        },
        watch: {
            search: function (val) {
                this.GetReparingOrderData(val, 1, this.formName);
            },
            formName: function () {
                this.GetReparingOrderData(this.search, 1, this.formName);
            }
        },
        methods: {
            IsSave: function () {

                this.show = false;

                this.GetReparingOrderData(this.search, this.currentPage);
            },
            getPage: function () {
                this.GetReparingOrderData(this.search, this.currentPage);
            },
            openmodel: function () {
                this.newReparingOrder = {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '',
                    nameArabic: '',
                    description: '',
                    reparingOrderTypes: this.formName,
                    isActive: true

                }
                this.show = !this.show;
                this.type = "Add";
            },
            GetReparingOrderData: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('ReparingOrder/ReparingOrderTypeList?isDropdown=false' + '&pageNumber=' + this.currentPage + '&searchTerm=' + this.search + '&ReparingOrderTypes=' + this.formName, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        debugger;

                        root.reparingOrderlist = response.data.results;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                        root.loading = false;
                    }
                    root.loading = false;
                });
            },
            EditReparingOrder: function (Id) {


                var root = this;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/ReparingOrder/ReparingOrderTypeDetail?Id=' + Id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data) {

                            root.newReparingOrder.id = response.data.id;
                            root.newReparingOrder.reparingOrderTypes = response.data.reparingOrderTypes;
                            root.newReparingOrder.name = response.data.name;
                            root.newReparingOrder.nameArabic = response.data.nameArabic;
                            root.newReparingOrder.description = response.data.description;
                            root.newReparingOrder.code = response.data.code;
                            root.newReparingOrder.isActive = response.data.isActive;
                            root.show = !root.show;
                            root.type = "Edit"
                        } else {
                            console.log("error: something wrong from db.");
                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });

            }
        },
        created: function () {
            this.$emit('input', this.$route.name);
        },
        mounted: function () {
            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
            this.GetReparingOrderData(this.search, 1);
        }
    }
</script>